export const getMinError = (min: number, label?: string) => `${label || 'Field'} must be at least ${min} characters`;
export const getMaxError = (min: number, label?: string) => `${label || 'Field'} must be at most ${min} characters`;
export const getRequireError = (label?: string) => `${label || 'Field'} is required`;
export const getLengthError = (length:number, label?: string) => `${label || 'Field'} must be exactly ${length} characters`;
